export default {"src":"/_next/static/media/CRH.4f78e5e8.svg","height":18,"width":18};